import React from "react";

interface CardProps {
    children: React.ReactNode;
    className?: string; // Allows additional custom styling
}

export function Card({ children, className }: CardProps) {
    return (
        <div
            className={`bg-white shadow-shadowAll rounded-cardRadius p-4 border border-feildBorder ${className}`}
        >
            {children}
        </div>
    );
};

export default Card;